import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { VopRequest, VopRequestService } from 'src/app/core/vop-request.service';
import { StoresFilterDialogComponent } from 'src/app/stores/stores-filter-dialog/stores-filter-dialog.component';

@Component({
  selector: 'app-vop-request-new-check-dialog',
  templateUrl: './vop-request-new-check-dialog.component.html',
  styleUrls: ['./vop-request-new-check-dialog.component.scss'],
})
export class VopRequestNewCheckDialogComponent {
  vop_new_check_from_group: FormGroup = this.form_service.vop_new_check_from_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_check_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<StoresFilterDialogComponent>,
    private form_service: FormService,
    private vop_request_service: VopRequestService,
    private error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {}

  ngOnInit(): void {
    this.vop_new_check_from_group.reset();
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.vop_new_check_from_group);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    if (this.isFormValid()) {
      const beneficiary_firstname: string = this.vop_new_check_from_group.get(
        this.form_service.beneficiary_firstname_label,
      )?.value;
      const beneficiary_lastname: string = this.vop_new_check_from_group.get(
        this.form_service.beneficiary_lastname_label,
      )?.value;
      const beneficiary_tax_code: string = this.vop_new_check_from_group.get(
        this.form_service.beneficiary_tax_code_label,
      )?.value;
      const iban = this.vop_new_check_from_group.get(this.form_service.iban_label)?.value;

      const params: VopRequest = {
        beneficiary_firstname: beneficiary_firstname || undefined,
        beneficiary_lastname: beneficiary_lastname || undefined,
        beneficiary_tax_code: beneficiary_tax_code || undefined,
        iban: iban || undefined,
      };

      this.setOrderRequirements(params);
    }
  }

  setOrderRequirements(vop_request: VopRequest): void {
    this.is_check_running = true;
    this.vop_request_service.createVopRequest(vop_request).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_check_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_check_running = false;
      },
    });
  }
}
